import Shivaleela from "../Images/Shivaleela_2.png";
import Ignatius from "../Images/Ignatious.png";

const doctorList = [
  {
    id: 1,
    name: "Dr. Shivaleela Dhotrad",
    image: Shivaleela,
    designation: "Dental Surgeon",
    speciality: null,
    description: `Dr. Shivaleela Dhotrad is a highly respected Dental Surgeon with nearly 30 years of clinical experience, known for ethical,
  patient-focused dental care in Hubli, Karnataka. She completed her BDS from KLE Vishwanath Katti Institute of Dental Sciences, Belgaum,
  and is registered with the Karnataka State Dental Council. She is the Founder of Dhotrad’s Sunny Dental Clinics, the first chain of dental
  clinics in Hubli, setting new standards for organized and quality dental care. A trailblazer in leadership, she is the first woman to serve 
  as both Secretary and President of the Indian Dental Association, Dharwad District. Renowned for her calm approach, clinical precision,
  and focus on preventive dentistry, Dr. Shivaleela is trusted by patients from across India and abroad, reflecting her lasting impact on
  dentistry in North Karnataka.`,
  },
  {
    id: 2,
    name: "Dr. Ignatius Fernandes",
    image: Ignatius,
    designation: "Orthodontist",
    speciality:
      "Speciality in Aligners, Braces, and Cosmetic Smile Transformations",
    description: `Dr. Ignatius Fernandes is a second-generation dentist and Orthodontist specializing in aligners, 
  braces, and cosmetic smile transformations. He holds BDS and MDS degrees in Orthodontics from SDM College of Dental Sciences & Hospital, Dharwad, 
  and is registered with the Karnataka and Goa State Dental Councils. An authorized provider of Invisalign and Spark Aligners,
  he also designs custom in-house aligners for precise, personalized results. With expertise in smile designing, cosmetic dentistry,
  and advanced orthodontic systems, Dr. Ignatius combines modern technology with clear patient communication to deliver confident, natural-looking smiles.`,
  },
];

export default doctorList;
